/*
 * 应急行业
 */
import React from 'react';
import SkeletonNew from 'components/solution/skeletonNew';
import { headBg, headBgM, challenge, frameSrc, frameSrcM, frame, advantage, scene, caseList } from 'constants/solution/er-solution';

const Group = () => {
  return (
    <SkeletonNew
      headFixed={true}
      challenge={challenge}
      caseList={caseList}
      advantage={advantage}
      scene={scene}
      frame={frame}
      headBg={headBg}
      headBgM={headBgM}
      title="应急行业解决方案"
      simpleDesc="高效提升应急效率 智慧护航社会安全"
      desc={`小鱼易连采用云计算与虚拟化技术，构建一体化“应急指挥融合平台”，通过标准音视频\n通信协议与各级单位、部门机构的视频系统实现互通互联，实现全时空、多部门、多业\n务的视频协同，让应急指挥直达一线，加快推进应急管理体系现代化。`}
      pageTitle="应急行业"
      tdkWord="emergency"
      frameSrc={frameSrc}
      frameSrcM={frameSrcM}
    />
  );
};

export default Group;
